<template>
  <div class="manager-trip-header-menu">
    <modal-dialog v-model:show="dialogVisible">
      <div class="confirm-btn-block" v-if="activeForm=='close'">
        <div>Завершить рейс?</div>
        <div>
          <button @click="closeTrip" class="save-button">Да</button>
          <button @click="dialogVisible=false" class="delete-btn">Нет</button>
        </div>
      </div>
      <div class="confirm-btn-block" v-else-if="activeForm=='in-way-confirm'">
        <div>Исполнитель или доверенность не отправлены в ТМС. Перевести в «В пути» всё равно?</div>
        <div>
          <button @click="confirmInWay" class="save-button">Да</button>
          <button @click="dialogVisible=false" class="delete-btn">Нет</button>
        </div>
      </div>
      <comment-form  v-else @updateComment="cancelWork" title="Причина отмены" />
    </modal-dialog>
    <div class="button-trip-menu">
      <div class="trip-menu-list">
        <div class="trip-menu-item" >
          <button 
          v-if="!trip.responsible_id" @click="getWork" >Принять в работу
          </button>
          <button v-else @click="openComment('cancel')">Отменить</button>
        </div>

        <div class="trip-menu-item" >
          <button v-if="isAdmin && trip.approval && isTripApprovalEnabled" @click="approval">Согласовать</button>
        </div>
        <div v-if="trip.is_my && trip.work_status.id != 7" class="trip-menu-item" >
          <button 
          v-if="trip.executor_id && trip.work_status.name != 'В пути' && trip.is_tms_candidate && trip.is_tms_attorney" 
          @click="inWay" :disabled="trip.approval && isTripApprovalEnabled" >В пути</button>
          <button v-else-if="trip.work_status.name != 'В пути' && isAdmin" @click="inWay" :disabled="trip.approval && isTripApprovalEnabled">В пути</button>
          <button v-if="true" @click="openComment('close')">Завершить</button>
        </div>

        
      </div>
      <div v-if="trip.approval && isTripApprovalEnabled" class="approval-msg">
        <p>Ждет согласования</p>
      </div>
      <div></div>
      
    </div>
  </div>
</template>

<script>
import { ref,computed } from 'vue'
import { useStore } from 'vuex';
import { useRoute } from 'vue-router';

export default {
  name: 'TripManagerMenu',
  setup(_,{emit}){
    const route = useRoute()
    const store = useStore()
    const activeForm = ref('close')
    const dialogVisible = ref(false)
    const isAdmin = computed(()=>store.getters['isAdmin'])
    const isTripApprovalEnabled = computed(()=>store.getters['isTripApprovalEnabled'])
    const trip = computed(()=>store.state.cargos.tripPage.item)

    const openComment = (name)=>{
      activeForm.value = name
      dialogVisible.value = true
    }

    const approval = () =>{
      store.dispatch('cargos/approval',{trip_id:route.params.id,form:{}})
    }

    const inWay = () => {
      if (!trip.value.is_tms_candidate || !trip.value.is_tms_attorney) {
        activeForm.value = 'in-way-confirm'
        dialogVisible.value = true
        return
      }
      store.dispatch('cargos/updateStatus',{link:route.params.id+'/in-way'})
    }

    const confirmInWay = () => {
      dialogVisible.value = false
      store.dispatch('cargos/updateStatus',{link:route.params.id+'/in-way'})
    }

    const getWork = () =>{
      store.dispatch('cargos/updateStatus',{link:route.params.id+'/get-work'})
      emit('forceInput')
    }

    const cancelWork = (comment)=>{
      dialogVisible.value = false
      store.dispatch('cargos/updateStatus',{link:route.params.id+'/cancel',form:{comment}})
    }

    const closeTrip = (comment)=>{
      store.dispatch('cargos/updateStatus',{link:route.params.id+'/close'})
      dialogVisible.value = false
    }

    return{
      approval,
      trip,
      isAdmin,
      isTripApprovalEnabled,
      inWay,
      confirmInWay,
      openComment,
      cancelWork,
      closeTrip,
      getWork,
      dialogVisible,
      activeForm
    }
  }
};
</script>

<style scoped>

.comment-form{
  display: flex;
  flex-direction: column;
  justify-content: center;

}

.comment-form strong{
  margin-bottom: 5px;
}

.trip-menu-list{ 
  
  display: flex;
  align-items: center;
}

.trip-menu-item button{
  margin-left: 10px;
  padding: 6px;
}

.trip-menu-item button:hover{
  cursor: pointer;
}

.button-trip-menu{
  display: flex;
  justify-content: center;
  justify-content: space-between;
  box-shadow: 4px 3px 5px #c2c1c1;
  padding: 5px;
  border: 2px solid rgba(121,121,121, 1.0);
  border-radius: 10px;
  margin-top: 20px;
}

.save-button {
  margin-right: 5px;
  margin-top: 2px;
  padding: 5px 12px;
  background-color: #007bff;
  color: #fff;
  border: none;
  border-radius: 4px;
  cursor: pointer;
}

.delete-btn {
  padding: 5px 8px; 
  border: 1px solid #C33245;
  border-radius: 4px;
  background-color: #C33245;
  color: #fff;
  cursor: pointer;
}

.confirm-btn-block{
  display: flex;
  flex-direction: column;
  align-items: center;
}

.approval-msg{
  margin-top: 6px;
  color: #C33245;
}
</style>